import {Margin} from '@logistics-frontend/blocks'
import React, {useCallback, useEffect, useRef, useState} from 'react'

import {useIsMobile} from '../../hooks'
import {Context} from './MarginContext'
import {MarginRectStrategy, MarginStrategyEffect} from './types'

type Props = {}

const isMarginEqual = (prevMargin: Margin, nextMargin: Margin): boolean => {
  return (
    prevMargin[0] === nextMargin[0] &&
    prevMargin[1] === nextMargin[1] &&
    prevMargin[2] === nextMargin[2] &&
    prevMargin[3] === nextMargin[3]
  )
}
const getNextMargin = (strategies: MarginRectStrategy[], offset: number): Margin => {
  const [nextTop, nextRight, nextBottom, nextLeft] = strategies.reduce(
    ([prevTop, prevRight, prevBottom, prevLeft], strategy) => {
      const {top = 0, right = 0, bottom = 0, left = 0} = strategy()

      return [prevTop + top, prevRight + right, prevBottom + bottom, prevLeft + left]
    },
    [0, 0, 0, 0],
  )

  return [nextTop + offset, nextRight + offset, nextBottom + offset, nextLeft + offset]
}

const MarginProvider: React.FC<React.PropsWithChildren<Props>> = ({children}) => {
  const isMobile = useIsMobile()
  const offset = isMobile ? 32 : 48
  const [margin, setMargin] = useState<Margin>([offset, offset, offset, offset])

  const [shouldUpdate, forceUpdate] = useState(0)
  const strategiesRef = useRef<MarginRectStrategy[]>([])
  const updateTimerRef = useRef<number>()
  const strategyEffect = useCallback<MarginStrategyEffect>(props => {
    if (updateTimerRef.current) {
      window.clearTimeout(updateTimerRef.current)
    }

    updateTimerRef.current = window.setTimeout(() => forceUpdate(prev => prev + 1), 700)
    strategiesRef.current.push(props.strategy)

    return () => {
      const index = strategiesRef.current.indexOf(props.strategy)

      if (index > -1) {
        strategiesRef.current.splice(index, 1)
        forceUpdate(prev => prev + 1)
      }
    }
  }, [])

  useEffect(() => {
    // избегаем первого обновления, ждем пока добавятся все зависимые элементы
    const strategies = shouldUpdate > 0 ? strategiesRef.current : []
    const nextMargin = getNextMargin(strategies, offset)

    setMargin(prevMargin => {
      return isMarginEqual(prevMargin, nextMargin) ? prevMargin : nextMargin
    })
  }, [offset, shouldUpdate])

  // useEffect(() => {
  //   // не большой хелпер, чтобы визуализировать как работают маргины на карте
  //   const div = document.createElement('div')
  //   div.style.cssText = `
  //     background-color: rgba(255, 0, 0, .3);
  //     position: absolute;
  //     z-index: 9000;
  //     pointer-events: none;
  //     top: ${margin[0]}px;
  //     right: ${margin[1]}px;
  //     bottom: ${margin[2]}px;
  //     left: ${margin[3]}px;
  //   `
  //   document.body.appendChild(div)
  //
  //   return () => {
  //     div.parentNode.removeChild(div)
  //   }
  // }, [margin])

  return <Context.Provider value={[margin, strategyEffect]}>{children}</Context.Provider>
}

export default MarginProvider
